// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/calculator-item/calculator-item.component.scss
// module id = 240
// module chunks = 0